import { render, staticRenderFns } from "./CustomizeTooltip.vue?vue&type=template&id=4de8f0d4&scoped=true"
import script from "./CustomizeTooltip.vue?vue&type=script&lang=ts"
export * from "./CustomizeTooltip.vue?vue&type=script&lang=ts"
import style0 from "./CustomizeTooltip.vue?vue&type=style&index=0&id=4de8f0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8f0d4",
  null
  
)

export default component.exports